module.exports = __webpack_public_path__ + "static/media/new-logo.d5ca6dce.png";